/* Locale-aware product-page navigation; never clears an existing cart. */
window.tgcPurchase = async function (button, mode) {
  const form = button.form;
  if (!form || form.dataset.purchaseBusy === 'true' || !form.reportValidity()) return;
  const error = form.querySelector('[data-purchase-error]');
  const buttons = Array.from(form.querySelectorAll('button'));
  const disabled = buttons.map((item) => item.disabled);
  form.dataset.purchaseBusy = 'true';
  buttons.forEach((item) => { item.disabled = true; });
  error.textContent = '';
  const root = window.Shopify?.routes?.root || '/';
  try {
    const response = await fetch(root + 'cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to load your cart. Please try again.');
    const cart = await response.json();
    const empty = cart.item_count === 0;
    // Buy Now on an empty cart adds exactly one unit. Otherwise retain the selected quantity.
    if (mode === 'buy' || empty) {
      const quantity = mode === 'buy' && empty ? 1 : Number(form.elements.quantity.value);
      const added = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.elements.id.value, quantity }] })
      });
      const data = await added.json();
      if (!added.ok) throw new Error(data.description || 'Unable to add this product. Please try again.');
    }
    if (mode === 'buy' && empty) {
      window.location.assign(root + 'cart');
    } else {
      // Shopify's native cart checkout submission preserves existing lines and discounts.
      const checkout = document.createElement('form');
      checkout.method = 'post';
      checkout.action = root + 'cart';
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
      checkout.appendChild(input); document.body.appendChild(checkout); checkout.submit();
    }
  } catch (err) {
    console.error('Product purchase failed:', err);
    error.textContent = err.message || 'Unable to continue. Please try again.';
  } finally {
    delete form.dataset.purchaseBusy;
    buttons.forEach((item, index) => { item.disabled = disabled[index]; });
  }
};
